import { fetcher } from "helpers/fetcher";

import { TGetTagListReq, TGetTagListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getTagList = async (payload: TGetTagListReq) => {
  return await fetcher<TGetTagListRes, any>(ENDPOINT.MANAGEMENT.GET_TAG_LIST, {
    headers: {
      [API_HEADER.BU_ID]: payload.idBu,
    },
    params: {
      keyword: payload.keyword,
      entity: payload.entity,
    },
  });
};

export const queryGetTagList = async (payload: TGetTagListReq) => {
  return (await getTagList(payload)).data;
};

queryGetTagList._key = (payload?: TGetTagListReq) => [
  ENDPOINT.MANAGEMENT.GET_TAG_LIST.url,
  payload,
];
